export default __webpack_public_path__ + "static/media/pic32.88aead28.jpg";